import React, { Component } from "react";
import client from "@culturehq/client";
import { BooleanField, Form, Loader, SubmitButton, Success } from "@culturehq/components";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";
import ErrorMessage from "components/common/ErrorMessage";

const recognitionTypes = {
  allDepartments: t("Meeting one-on-one with a user in every department"),
  eventCreation: t("Creating events of the same type (3, 5, and 10 times)"),
  didRecognize: t("Recognizing colleagues (5 and 10 times)"),
  wasRecognized: t("Being recognized by colleagues (5 and 10 times)"),
  inviteCreation: t("Inviting coworkers to join CultureHQ (5 and 10 times)")
};

const recognitionTypeKeys = Object.keys(recognitionTypes);

const initialValuesFrom = settings => recognitionTypeKeys.reduce(
  (object, key) => ({ ...object, [key]: settings[key] }), {}
);

class AutoRecognitionsContext extends Component {
  state = {
    settings: null,
    error: null,
    success: false,
    loading: true
  };

  async componentDidMount() {
    try {
      const { autoRecognitionSettings } = await client.getAutoRecognitionSettings();

      this.setState({ loading: false, settings: autoRecognitionSettings });
    } catch (error) {
      this.setState({ loading: false, error });
    }
  }

  handleSubmit = async options => {
    try {
      this.setState({ error: null, success: false });

      const { autoRecognitionSettings } = await client.updateAutoRecognitionSettings(options);

      this.setState({ success: true, settings: autoRecognitionSettings });
    } catch (error) {
      this.setState({ error, success: false });
    }
  };

  render() {
    const { profile } = this.props;
    const { settings, loading, error, success } = this.state;

    const { organization: { userCreatedInvitesEnabled: invitesEnabled } } = profile;
    const formKeys = (
      invitesEnabled
        ? recognitionTypeKeys
        : recognitionTypeKeys.slice(0, recognitionTypeKeys.length - 1)
    );

    return (
      <>
        <PageHeader title={t("Manage Auto Recognitions")}>
          <Trans>
            The below is a list of all actions on the platform that CultureBot
            will automatically recognize. Toggle to enable or disable each
            action.
          </Trans>
        </PageHeader>
        <Loader loading={loading}>
          {error && <ErrorMessage error={error} />}

          {success && (
            <Success><Trans>Success!</Trans></Success>
          )}

          {settings && (
            <Form initialValues={initialValuesFrom(settings)} onSubmit={this.handleSubmit}>
              {formKeys.map(key => (
                <BooleanField key={key} name={key}>
                  {recognitionTypes[key]}
                </BooleanField>
              ))}
              <SubmitButton primary>
                {submitting => (submitting ? t("Submitting...") : t("Save Changes"))}
              </SubmitButton>
            </Form>
          )}
        </Loader>
      </>
    );
  }
}

const AutoRecognitions = () => {
  const { profile } = useProfile();

  return <AutoRecognitionsContext profile={profile} />;
};

export default AutoRecognitions;
